// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";

// Afidium
import { TravellerFormComponent } from './travellerForm.component';
import { TravellerFieldsetModule } from "../../fieldsets/traveller-fieldset/traveller-fieldset.module";
import { CardFormModule } from '../card-form/card-form.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { NotificationModule } from "libraries/component/notification/notification.module";
import { ActionQualityHelperModule } from "libraries/service/action-quality-helper/action-quality-helper.module";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TravellerFieldsetModule,
        CardFormModule,
        PipesModule,
        NotificationModule,
        ActionQualityHelperModule,
    ],
    declarations: [
        TravellerFormComponent,
    ],
    exports: [
        TravellerFormComponent,
    ],
})
export class TravellerFormModule {  }
